<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">{{pageTitle}}</h1>
    <span class="close" (click)="close()"></span>
  </div>
  <div class="dialog__body">
    <div class="dialog__contents">
      <div class="section section--file-import">
        <div class="section__header header header--mb-15">
          <div class="header__title">
            {{ title }}のCSVデータ取り込み
          </div>
        </div>
        <div class="section__content import-container">
          <div
            *ngIf="!isImportInProgress; else showImportLoadingBar"
            class="import-btn-group"
          >
            <label
              class="import-btn-group__btn btn btn--white btn--outline-gray"
            >
              <input #fileinput type="file" (change)="onInputChanged($event)" />
              ファイル選択
            </label>
            <span class="import-btn-group__label">
              {{
                fileToUpload
                  ? fileToUpload.name
                  : "ファイルが選択されていません"
              }}
            </span>
          </div>
          <ng-template #showImportLoadingBar>
            <div class="loading">
              <svg class="loading__spinner" viewBox="0 0 50 50">
                <circle
                  class="loading__spinner__path"
                  cx="25"
                  cy="25"
                  r="20"
                ></circle>
              </svg>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="dialog__footer">
    <button class="dialog__button dialog__button--accent" (click)="close()">
      キャンセル
    </button>
    <button
      class="dialog__button dialog__button--primary btn--green"
      [disabled]="!fileToUpload"
      (click)="onImport()"
    >
      取り込み実行
    </button>
  </div>
</div>
